/**
 * QR rendering for the 80 mm slip.
 *
 * `qrcode` (npm) encodes to a plain SVG STRING — no canvas, no DOM node — which
 * is exactly what the hidden print iframe needs. Error correction M is the
 * thermal-print sweet spot: enough redundancy to survive a slightly starved
 * printhead without inflating the module count so far that a 48 mm code gets
 * too dense for a scratched phone camera.
 */

import QRCode from 'qrcode';

export async function renderQrSvg(text: string): Promise<string> {
  return QRCode.toString(text, {
    type: 'svg',
    errorCorrectionLevel: 'M',
    margin: 0,
    color: { dark: '#000000', light: '#ffffff' },
  });
}
